import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconChatStyle0 = stylesCss;

const BiIconChat$1 = /*@__PURE__*/ proxyCustomElement(class BiIconChat extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'b0828ddf393e480214c7a4f67cf23e76ba29e1f6', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '9627c3c3b9b571063d230904fce50a0f870cb236', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'e3edd61fc377dec82ceab70acb7030316feb3d4a', "fill-rule": 'evenodd', d: 'M3.875 5.073h17.977v11.985H9.119A3.744 3.744 0 0 0 5.375 20.8h-1.5zm1.5 12.057a5.228 5.228 0 0 1 3.744-1.572h11.233V6.572H5.375zm1.996-9.311h10.984v1.5H7.371zm0 2.496h10.984v1.5H7.371zm0 2.497h5.492v1.5H7.372v-1.5Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconChatStyle0; }
}, [1, "bi-icon-chat", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-chat"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-chat":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconChat$1);
            }
            break;
    } });
}

const BiIconChat = BiIconChat$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconChat, defineCustomElement };
